var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatOutlinedMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.47546 6.58772C2.47546 4.58569 4.09843 2.96272 6.10046 2.96272H13.8995C15.9015 2.96272 17.5245 4.58569 17.5245 6.58772V10.4976C17.5245 12.4996 15.9015 14.1226 13.8995 14.1226H7.64054L3.86511 16.8684C3.28677 17.289 2.47546 16.8758 2.47546 16.1607V6.58772ZM6.10046 4.21272C4.78879 4.21272 3.72546 5.27604 3.72546 6.58772V15.4243L7.0697 12.9921L7.23406 12.8726H7.4373H13.8995C15.2112 12.8726 16.2745 11.8093 16.2745 10.4976V6.58772C16.2745 5.27604 15.2112 4.21272 13.8995 4.21272H6.10046ZM6.89734 7.00959C6.89734 6.66442 7.17716 6.38459 7.52234 6.38459H13.5223C13.8675 6.38459 14.1473 6.66442 14.1473 7.00959C14.1473 7.35477 13.8675 7.63459 13.5223 7.63459H7.52234C7.17716 7.63459 6.89734 7.35477 6.89734 7.00959ZM7.52234 9.38459C7.17716 9.38459 6.89734 9.66442 6.89734 10.0096C6.89734 10.3548 7.17716 10.6346 7.52234 10.6346H11.5223C11.8675 10.6346 12.1473 10.3548 12.1473 10.0096C12.1473 9.66442 11.8675 9.38459 11.5223 9.38459H7.52234Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatOutlinedMobile);
export default __webpack_public_path__ + "static/media/chat-outlined-mobile.8f01bb9447c0024013e37a554c0c8503.svg";
export { ForwardRef as ReactComponent };